module.exports = __webpack_public_path__ + "img/translate-sixteen.6785f7c9.png";